import { ReportStatusTypes } from 'models/ReportStatus.model'

import { FormSubmissionSummaryDTO } from '../../models/FormSubmissionSummaryDTO.model'
import ScrubstrApiQueryService from '../ScrubstrApiQueryService/ScrubstrApiQueryService'

export function isReviewReportPending(
  reviewId: number,
  reportStatus: ReportStatusTypes | null | undefined,
  reportedReviewIds: Set<number>,
): boolean {
  return reportedReviewIds.has(reviewId) || reportStatus === ReportStatusTypes.ACTIVE
}

export function getPendingReportIdsFromReviews(reviews: FormSubmissionSummaryDTO[]): number[] {
  return reviews.filter((r) => r.reportStatus === ReportStatusTypes.ACTIVE).map((r) => r.id)
}

export function mergeReportedReviewIds(existing: Set<number>, ids: number[]): Set<number> {
  if (ids.length === 0) return existing
  return new Set([...existing, ...ids])
}

export class ReviewService {
  /**
   * Report a review by id
   */
  public async reportReview(reviewId: number, isReported: ReportStatusTypes): Promise<void> {
    const scrubstrApiQueryService = new ScrubstrApiQueryService()

    await scrubstrApiQueryService.post({
      data: { isReported: isReported },
      endpoint: `report-review/${reviewId}`,
    })
  }

  /**
   * Fetch submission IDs with a pending report (reportStatus = active).
   * Same list for every authenticated user.
   */
  public async getMyReportedReviews(): Promise<number[]> {
    const scrubstrApiQueryService = new ScrubstrApiQueryService()

    const response = await scrubstrApiQueryService.get<{ reportedSubmissionIds: number[] }>({
      endpoint: 'report-review/my-reported-reviews',
    })

    return response?.reportedSubmissionIds ?? []
  }
}
